module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'projects',
        showHead: true,
        showIDs: true,
        showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {
            statusFlagsSummary: true,
            customer: true,
            terms: true,
        },
        rowActionsInline: true,
        rowActionsProperties: {
            // colWidth: '105px',
            colWidth: '75px',
        },
        rowActions: {
            edit: true,
            customs: [
                // {
                //     buttonType: 'showLocation',
                // },
                {
                    buttonType: 'delete',
                    neutral: true,
                }
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_projects': true,
            'resourceChanged.bo_customers': false,
            'resourceChanged.bo_employees': false,
            'resourceChanged.bo_projectTerms': true,
            'resourceChanged.bo_projectTermJobs': true,
            'resourceChanged.bo_customerContacts': false,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'projectID',
                direction: 'desc'
            }]
        }
    },

    methods: {
        onPrepareDone(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true, mode: 'allInOne' },
                ]
            }
        },

        // TODO: heartbeat?
        onSubmitDone(callerComponent, entityID, entityData, insertPerformed){
            switch(((callerComponent || {}).config || {}).entityContext){
                case 'projects':
                    if(insertPerformed && entityID && entityData){
                        this.showEdit(entityID, entityData)
                    }
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_status'
                ) ||
                (key === 'resourceChanged.bo_status' && this.isAtLeastOneStatusIDLoaded(message.data.statusIDs))
            )){
                this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
            }
        },
    }
}